<template>
  <nav class="navbar-side" role="navigation">
    <div class="navbar-collapse sidebar-collapse collapse">
      <ul id="side" class="nav navbar-nav side-nav">
        <li class="side-user hidden-xs">
           <img class="img-circle" src="~assets/img/profile-placeholder.jpg" alt="">
          <p class="welcome">
            <font-awesome :icon="['far' ,'key']"/> Logged in as
          </p>
          <p class="name tooltip-sidebar-logout">
            {{ $user.firstname }}
            <span class="last-name">
              {{ $user.surname }}
            </span>
            <a :href="$serverRoute('logout')" style="color: inherit" class="logout_open" data-toggle="tooltip" data-placement="top" title="Logout">
              <font-awesome :icon="['fas' ,'sign-out']"/>
            </a>
          </p>
          <div class="clearfix"></div>
        </li>

        <template v-if="$user.is_admin">
          <li>
            <server-link to="">
              <font-awesome fixed-width :icon="['fas' ,'tachometer-alt']" /> Dashboard
            </server-link>
          </li>

          <li>
            <server-link to="customers">
              <font-awesome fixed-width :icon="['fas' ,'users']" /> Customers
            </server-link>
          </li>

          <li>
            <server-link to="products">
              <font-awesome fixed-width :icon="['fab' ,'shirtsinbulk']" /> Products
            </server-link>
          </li>

          <li>
            <server-link to="firestations">
              <font-awesome fixed-width :icon="['fas' ,'building']" /> Fire Stations
            </server-link>
          </li>

          <li>
            <server-link to="firefighters">
              <font-awesome fixed-width :icon="['fas' ,'users']" /> Firefighters
            </server-link>
          </li>

          <li>
            <server-link to="garment-tracker">
              <font-awesome fixed-width :icon="['fas' ,'briefcase']" /> Garments
            </server-link>
          </li>

          <li>
            <server-link to="scanners">
              <font-awesome fixed-width :icon="['fas' ,'barcode']" /> Scanners
            </server-link>
          </li>

          <li>
            <server-link to="reports">
              <font-awesome fixed-width :icon="['fas' ,'book']" /> Reports
            </server-link>
          </li>

          <li>
            <server-link to="stocktake">
              <font-awesome fixed-width :icon="['fas' ,'bars']" /> Stocktake
            </server-link>
          </li>

          <li>
            <server-link to="disputes">
              <font-awesome fixed-width :icon="['fas' ,'exclamation']" /> Garment Disputes
            </server-link>
          </li>

          <li>

            <router-link :to="{ name: 'delivery-runs.pending' }" exact>
              <font-awesome fixed-width :icon="['fas' ,'truck']" /> Pickup &amp; Delivery Requests
            </router-link>
          </li>

          <li>
            <router-link :to="{ name: 'delivery-runs.run-sheets' }" exact>
              <font-awesome fixed-width :icon="['fas' ,'road']" /> Run Sheets
            </router-link>
          </li>

          <li>
            <a class="inactive" href="javascript:;" data-parent="side" data-toggle="collapse"
               data-target="#i-classfa-fa-cogsi-settings-i-classfa-fa-caret-downi" aria-expanded="true">
              <font-awesome fixed-width :icon="['fas' ,'cogs']" /> Settings <font-awesome fixed-width :icon="['fas' ,'caret-down']" /></a>
            <ul class="nav menu_level_1 collapse" id="i-classfa-fa-cogsi-settings-i-classfa-fa-caret-downi" aria-expanded="true" style="">
              <li class="first">
                <server-link to="settings/application">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Application
                </server-link>
              </li>
              <li>
                <server-link to="settings/barcode-setup">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Barcode Scanner Setup
                </server-link>
              </li>
              <li>
                <server-link to="users">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Users
                </server-link>
              </li>
              <li>
                <server-link to="settings/countries">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Countries
                </server-link>
              </li>
              <li>
                <server-link to="settings/scanners">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Scanners
                </server-link>
              </li>
              <li>
                <server-link to="settings/locations">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Locations
                </server-link>
              </li>
              <li>
                <server-link to="settings/pricing">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Default Pricing
                </server-link>
              </li>
              <li>
                <server-link to="settings/repair-reasons">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Repair Reasons
                </server-link>
              </li>
              <li>
                <server-link to="settings/notfitforpurposereason">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Not Fit For Purpose Reasons
                </server-link>
              </li>
              <li>
                <server-link to="settings/firestation-groups">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Firestation Groups
                </server-link>
              </li>
              <li>
                <server-link to="settings/firestation-regions">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Firestation Regions
                </server-link>
              </li>
              <li class="last">
                <server-link to="settings/nonworkdays">
                  <font-awesome fixed-width :icon="['far' ,'angle-double-right']" /> Non Work Days
                </server-link>
              </li>
            </ul>
          </li>
        </template>

        <template v-if="$user.is_manager">
          <template v-if="$user.role === roles.HQ_MANAGER">
            <li>
              <server-link to="firefighter-garments">
                <font-awesome fixed-width :icon="['fas' ,'user']" /> Your Garments
              </server-link>
            </li>
            <li>
              <server-link to="firestation-firefighters">
                <font-awesome fixed-width :icon="['fas' ,'users']" /> Firestation Firefighter
              </server-link>
            </li>
            <li>
              <server-link to="pickup-requests">
                <font-awesome fixed-width :icon="['fas' ,'truck']" /> Request Pickup
              </server-link>
            </li>
            <li>
              <server-link to="garment-tracker/hq">
                <font-awesome fixed-width :icon="['fas' ,'briefcase']" /> Garments
              </server-link>
            </li>
            <li>
              <server-link to="garment-reassign-request">
                <font-awesome fixed-width :icon="['fas' ,'briefcase']" /> Garment Reassign
              </server-link>
            </li>
            <li class="last">
              <server-link to="repair-quotes">
                <font-awesome fixed-width :icon="['fas' ,'wrench']" /> Repair Quotes
              </server-link>
            </li>
          </template>
        </template>
      </ul><!-- /.side-nav -->
    </div><!-- /.navbar-collapse -->
  </nav><!-- /.navbar-side -->
</template>
<script>
import { roles } from 'utils/auth'

export default {
  computed: {
    roles: () => roles
  }
}
</script>
